import { Box, CircularProgress } from '@mui/material';
import { CSSProperties } from 'react';

const Loader = ({ sx }: { sx?: CSSProperties }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        height: '100%',
        width: '100%',
        ...sx,
      }}
    >
      <Box
        sx={{
          backgroundColor: '#64646433',
          width: '56px',
          height: '56px',
          borderRadius: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          display: 'flex',
        }}
      >
        <CircularProgress
          size={32}
          thickness={6}
          color='warning'
          sx={theme => ({
            color: '#FFF726',
            ...theme.applyStyles('dark', {
              color: theme.palette.grey[800],
            }),
          })}
        />
      </Box>
    </Box>
  );
};

export default Loader;
